import { X4bActivityDto } from '../../vehicle/engine/X4bActivityDto';
import styles from './route-details.module.css';

type RouteDetailsProps = {
	activity: X4bActivityDto,
	gap?: string,
	flex?: string
}
// The control is used in several places, so, activity may be not suitable for all. Feel free to adapt it for your case.
const RouteDetails = ({ gap = 'gap-1', flex = '', activity }: RouteDetailsProps) => {

	return (
		<div className={`${styles.routeColumn} ${flex}`}>
			<div className={`${styles.routePoint} ${gap}`}>
				<div className={styles.routeIconLineContainer}>
					<img
						src="/images/svg/pickup-icon.svg"
						alt="Pickup Icon"
						className="shrink-0"
						width={20}
						height={20}
					/>
					<div className={styles.routeLine} />
				</div>
				<div className="h-[84px]">
					<p className={styles.routeLabel}>
						{activity.Pickup?.PlaceName}
					</p>
					<p className={styles.routeDescription}>
						{activity.Pickup?.Address}
					</p>
				</div>
			</div>
			<div className={`${styles.routePoint} ${gap}`}>
				<img
					src="/images/svg/destination-icon.svg"
					alt="Destination Icon"
					className="shrink-0"
					width={20}
					height={20}
				/>
				<div className="h-[44px]">
					<p className={styles.routeLabel}>
						{activity.Dropoff?.PlaceName}
					</p>
					<p className={styles.routeDescription}>
						{activity.Dropoff?.Address}
					</p>
				</div>
			</div>
		</div>
	);
};

export default RouteDetails;
